import { render, staticRenderFns } from "./ProductinfoPage.vue?vue&type=template&id=747d234e"
import script from "./ProductinfoPage.vue?vue&type=script&lang=js"
export * from "./ProductinfoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports